
import { mapState } from "vuex";

export default {
  props: { banners: { type: Array, default: () => [] } },

  data: () => ({ filterAboveTopSection: false, productListVisible: false }),

  computed: {
    ...mapState(["siteConfig"]),
    ...mapState("app", ["isFilterPanelOpen", "topBannerHeight"]),
    productListClass() {
      return this.isFilterPanelOpen ? "hidden  lg:block" : "";
    },
    paddingTopStyle() {
      return `${this.topBannerHeight + 60}px`;
    },
    hideMenuItems() {
      return this.filterAboveTopSection && this.productListVisible;
    },
    intersection() {
      return { rootMargin: `-${this.siteConfig.headerHeight}px 0px 0px 0px` };
    },
  },

  watch: {
    hideMenuItems(newVal) {
      if (newVal) {
        this.$store.dispatch("app/hideMenuItems");
      } else {
        this.$store.dispatch("app/showMenuItems");
      }
    },
  },

  methods: {
    visibilityChanged(isVisible, entry) {
      const isAboveTopSection =
        entry.target.getBoundingClientRect().y < this.siteConfig.headerHeight &&
        !isVisible;
      this.filterAboveTopSection = isAboveTopSection;
    },
  },
};
